// Non-dietary "Prefer" options for Settings > Culinary Interests. They only re-rank search
// results; nothing is filtered out. `searchValues` are the terms matched against the index.
export const CULINARY_TOPIC_OPTIONS = [
  { id: 'baking', label: 'Baking', searchValues: ['Baking'] },
  { id: 'bread', label: 'Bread', searchValues: ['Bread'] },
  { id: 'desserts-pastry', label: 'Desserts & Pastry', searchValues: ['Dessert', 'Pastry'] },
  { id: 'family', label: 'Family', searchValues: ['Family'] },
  { id: 'professional', label: 'Professional', searchValues: ['Professional', 'Chef'] },
  { id: 'quick-easy', label: 'Quick & Easy', searchValues: ['Quick', 'Easy'] },
  { id: 'spicy', label: 'Spicy', searchValues: ['Spicy'] },
];

// Continents first, then countries, each alphabetical. `continents` / `countries` are exact
// values of the continent.raw / country.raw index fields (what the search filters use), so a
// recipe is only boosted when it is actually tagged with the region.
export const CULINARY_REGION_OPTIONS = [
  { id: 'africa', label: 'Africa', continents: ['Africa'] },
  { id: 'americas', label: 'Americas', continents: ['Americas'] },
  { id: 'asia', label: 'Asia', continents: ['Asia'] },
  { id: 'europe', label: 'Europe', continents: ['Europe'] },
  { id: 'middle-east', label: 'Middle East', continents: ['Middle East'] },
  { id: 'oceania', label: 'Oceania', continents: ['Oceania'] },
  { id: 'australia', label: 'Australia', countries: ['Australia'], newRow: true },
  { id: 'canada', label: 'Canada', countries: ['Canada'] },
  { id: 'china', label: 'China', countries: ['China'] },
  { id: 'france', label: 'France', countries: ['France'] },
  { id: 'italy', label: 'Italy', countries: ['Italy'] },
  { id: 'japan', label: 'Japan', countries: ['Japan'] },
  { id: 'mexico', label: 'Mexico', countries: ['Mexico'] },
  { id: 'new-zealand', label: 'New Zealand', countries: ['New Zealand'] },
  { id: 'south-africa', label: 'South Africa', countries: ['South Africa'] },
  { id: 'spain', label: 'Spain', countries: ['Spain'] },
  { id: 'thailand', label: 'Thailand', countries: ['Thailand'] },
  { id: 'uk', label: 'UK', countries: ['UK', 'United Kingdom'] },
  { id: 'usa', label: 'USA', countries: ['USA', 'United States'] },
];

export const CULINARY_TOPIC_OPTION_IDS = CULINARY_TOPIC_OPTIONS.map(option => option.id);
export const CULINARY_REGION_OPTION_IDS = CULINARY_REGION_OPTIONS.map(option => option.id);

// Index fields the preferred topic terms are matched against (analyzed text fields).
export const CULINARY_PREFER_FIELDS = ['additional_keywords', 'book_tags', 'course'];

const searchValuesFor = (options, ids = []) =>
  options.filter(option => ids.includes(option.id)).flatMap(option => option.searchValues);

const regionValuesFor = (ids = [], key) => [
  ...new Set(
    CULINARY_REGION_OPTIONS.filter(option => ids.includes(option.id)).flatMap(
      option => option[key] || [],
    ),
  ),
];

export const getCulinarySearchValues = ({ topics = [] } = {}) => [
  ...new Set(searchValuesFor(CULINARY_TOPIC_OPTIONS, topics)),
];

export const getCulinaryRegionTerms = ({ regions = [] } = {}) => ({
  continents: regionValuesFor(regions, 'continents'),
  countries: regionValuesFor(regions, 'countries'),
});
